module.exports = __webpack_public_path__ + "page-92d620f2/xingButterfly-3a6560454ed332dd952fb8c3bfb4604c.svg";